import React from 'react'
import tw from 'tailwind-styled-components'
import {UserEventsByDay, UserEventsByTime} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {BgOpacityContainer} from '@components/common/bg-opacity-container/bg-opacity-container'
import {getDate} from '@components/statistics/stats-timeline/item/tiles'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {StatisticsTile} from './tile'

const TwLabel = tw.div`
  sticky
  font-semibold
  text-third-old
  w-88
  flex
  justify-center
  m-auto
  mt-16
  top-8
`

interface Props {
  date: string
  eventsByDay: UserEventsByDay
}

interface PropsTiles extends Props {
  events: UserEventsByTime
}

const Tiles = (props: PropsTiles) => {
  const {events} = props
  const box = Sync.getCurrentSandbox()

  const hierarchy = DepartmentsClient.getHierarchy(box)
  return (
    <>
      {Object.keys(events).map(k => {
        return (
          <StatisticsTile
            user={UserProxy.create(box.getUser(events[+k].user))}
            event={events[+k]}
            time={+k}
            key={k}
            hierarchy={hierarchy}
          />
        )
      })}
    </>
  )
}

export const StatisticsTiles = (props: Props) => {
  const {eventsByDay, date} = props

  return (
    <div className="relative">
      <TwLabel>
        <BgOpacityContainer
          bgColorClassName="bg-chat-list-hover-old rounded-8"
          bgOpacityClassName="opacity-70"
          className="w-full text-center border border-solid rounded-8 border-main-old"
        >
          {getDate(date)}
        </BgOpacityContainer>
      </TwLabel>

      <div className="w-full">
        <Tiles {...props} events={eventsByDay[date]} />
      </div>
    </div>
  )
}
